import React, { useState, useEffect } from 'react';
import _ from 'lodash';

const Search = ({ searchPath, mostSearchedAll, mostSearchedDisplay, currentUserId, categoryId = 0, categoryName = "", categoryRoute = ""}) => {
  const [showMostSearchDropdown, setShowMostSearchDropdown] = useState(false);
  const [showPredictiveSearch, setShowPredictiveSearch] = useState(false);
  const [predictiveSearchResults, setPredictiveSearchResults] = useState([]);
  const [firstLoad, setfirstLoad] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [debounce] = useState((term) => _.debounce((term) => {getPredictiveSearchResults(term)}, 500));
  const [placeholder, setPlaceholder] = useState('Search for articles by keyword, title, author, or citation');

  useEffect(() => {
    const mql = window.matchMedia('(max-width: 640px)');

    const updatePlaceholder = (e) => {
      setPlaceholder(
        e.matches ? 'Search' : 'Search for articles by keyword, title, author, or citation');
    };

    updatePlaceholder(mql);
    mql.addEventListener('change', updatePlaceholder);
    return () => mql.removeEventListener('change', updatePlaceholder);
  }, []);

  useEffect(() => {
    if (firstLoad) {
      setfirstLoad(false)
      return
    }

    if (searchTerm.length > 0) {
      debounce(searchTerm);
      setShowMostSearchDropdown(false)
    } else {
      setShowPredictiveSearch(false)
      setShowMostSearchDropdown(true)
    }
  }, [searchTerm])

  const renderMostSearched = (terms) => {
    // TODO: update MostSearchAggregate to support searching by categories
    return terms.map((term) => {
      return <a key={term} target="_blank" href={`/articles?page=1&q=${term}&order=%7B%22attr%22:%22_score%22,%22dir%22:%22desc%22,%22text%22:%22Relevance%22%7D&advanced=false&filters=&obeySort=false&searched=true`} onClick={() => fireAmplitude(term)}>{term}</a>
    })
  }

  const renderPredictiveSearchResults = () => {
    if (predictiveSearchResults.length < 1) {
      return (noResultsHeader())
    } else {
      return predictiveSearchResults.map(function(result, index) {
        return (
            <div key={index} className="search-result-container">
              {renderArticleResult(result)}
            </div>
        )
      })
    }
  }

  const renderArticleResult = (article) => {
    return (
        <a key={article.id}
           href={`/articles/${article.id}`}
           target="_blank">
          <div className="header-container">
            <div className="article-type">{article.type}</div>
            <div className="article-published-date">{article.published_at}</div>
            <div className="category-container show-for-large-up">
              {(article.categories && article.categories.length > 0) &&
                  renderPredictiveSearchCategories(article.categories)
              }
            </div>
          </div>
          <div className="article-title">{article.title}</div>
        </a>
    )
  }

  const renderPredictiveSearchCategories = (categories) => {
    return categories.map((category, index) => {
      return (
          <div key={index} className="article-category">
            <span>{category}</span>
          </div>
      )
    })
  }

  const renderResults = () => {
    if (searchTerm.length > 0) {
      return renderPredictiveSearchResults()
    } else {
      return renderMostSearched(mostSearchedAll)
    }
  }

  const renderDropdown = () => {
    if (showMostSearchDropdown || showPredictiveSearch) {
      const noResultsClass = (searchTerm.length > 0 && predictiveSearchResults.length < 1) ?  'no-results' : '';
      return (
          <div className={`predictive-search-results ${noResultsClass}`}>
            {showMostSearchDropdown && dropDownHeader()}
            {renderResults()}
        </div>
      )
    }
  }

  const dropDownHeader = () => {
    return (
      <div className="header">
        <span>Most Searched:</span>
      </div>
    )
  }

  const noResultsHeader = () => {
    return (
        <div>
          <span>No Results</span>
        </div>
    )
  }

  const getPredictiveSearchResults = (term) => {
    $.ajax({
      method: 'GET',
      url: "/articles/search_suggestions",
      data: {query: term, category_ids: [categoryId]},
      dataType: 'json',
      success: function(res) {
        setPredictiveSearchResults(res)
        setShowPredictiveSearch(true)
      },
      error: function(res) {
      }
    }, 'json');

  }

  const fireAmplitude = (term) => {
    $.ajax("/amplitudes", {
      dataType: "json",
      type: "POST",
      data: {
              event_type: 'mostSearchedTermClicked',
              user_id: currentUserId,
              term: term
            }
    })
  }

  const handleChange = (e) => {
    const term = e.target.value
    setSearchTerm(term)
  }

  const handleFocus = (e) => {
    const term = e.target.value;
    if (term.length == 0) {
      setShowMostSearchDropdown(mostSearchedAll ? true : false)
    } else {
      setShowPredictiveSearch(true)
    }
  }

  const handleOnBlur = (e) => {
    const term = e.target.value
    // without setTimeout the onblur event closed the dropdown before the a tag href is called
    setTimeout(() => {
      setShowPredictiveSearch(false)
      setShowMostSearchDropdown(false)
    }, 100)
  }

  const specialtySearchPath = categoryName.length > 0 ? `/${categoryRoute}` : searchPath;

  return (
    <React.Fragment>
      <div className="form-section">
        <form method="get" action={specialtySearchPath} onChange={handleChange} className="search-form-container" autoComplete="off">
          <label className="search-form-container">
            <img className='search-icon' src="https://public.cureus.com/homepage_v2/search-icon-w.png"/>
            <input className="search-field" type="text" name="q" placeholder={placeholder} onFocus={handleFocus}
                   onBlur={handleOnBlur}/>
            <input type="hidden" name={"source"} value={"homeSearch"}/>
            <input type="hidden" name={"searched"} value={"true"}/>
          </label>
        </form>
        {renderDropdown()}
      </div>
    </React.Fragment>
  )
}

export default Search;